import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSelectedDatasetName } from 'Datasets/store';
import useRouter from 'Router/index';
import BinaryPlotTooltip from 'PhenotypeView/views/glr/components/BinaryPlotTooltip/BinaryPlotTooltip';
import { isWgsOrWes } from 'Common/utils/isWesWgs/isWesWgs';
import { isDatasetWithAncestry } from 'Common/utils';
export const useBinaryPlotTooltip = (associationData) => {
    const { getParams } = useRouter();
    const { datasetVersionId } = getParams();
    const selectedDatasetName = useSelectedDatasetName();
    const hasAncestryData = isDatasetWithAncestry(selectedDatasetName);
    return useCallback((association) => (_jsx(BinaryPlotTooltip, { phenotypeAssociation: association, associationData: associationData, datasetVersionId: !isWgsOrWes(datasetVersionId) ? datasetVersionId : undefined, hasAncestryData: hasAncestryData }, void 0)), [
        associationData,
        datasetVersionId,
        hasAncestryData,
    ]);
};
